export class CompanySettings {
    Id: number;
    CompanyId: number;
    UseMileageScale: 'FrenchLegal' | 'GlobalCompanyRate' | 'CustomUserRate';
    RateAuto: number;
    RateMoto: number;
    RateScooter: number;
    RateBicycle: number;
    BicycleTotalMax: number;
    CompanyLogoUrl: string;
    SupportEmail: string;
    IsSubjectToVAT: boolean;
    ReportNameTemplateEnabled: boolean;
    ReportNameTemplate: string;
    ReportNameTemplateForced: boolean;

    constructor(model?: CompanySettings) {
        if (model) {
            this.Id = model.Id;
            this.CompanyId = model.CompanyId;
            this.UseMileageScale = model.UseMileageScale;
            this.RateAuto = model.RateAuto;
            this.RateMoto = model.RateMoto;
            this.RateScooter = model.RateScooter;
            this.RateBicycle = model.RateBicycle;
            this.BicycleTotalMax = model.BicycleTotalMax;
            this.CompanyLogoUrl = model.CompanyLogoUrl;
            this.SupportEmail = model.SupportEmail;
            this.IsSubjectToVAT = model.IsSubjectToVAT;
            this.ReportNameTemplateEnabled = model.ReportNameTemplateEnabled;
            this.ReportNameTemplate = model.ReportNameTemplate;
            this.ReportNameTemplateForced = model.ReportNameTemplateForced;
        } else {
            this.Id = 0;
            this.CompanyId = 0;
            this.UseMileageScale = 'FrenchLegal';
            this.RateAuto = 0;
            this.RateMoto = 0;
            this.RateScooter = 0;
            this.RateBicycle = 0;
            this.BicycleTotalMax = 0;
            this.CompanyLogoUrl = null;
            this.SupportEmail = null;
            this.IsSubjectToVAT = true;
            this.ReportNameTemplateEnabled = false;
            this.ReportNameTemplate = '';
            this.ReportNameTemplateForced = false;
        }
    }
}
